import type { SigningAlert } from "@/core/cms/alert";
import { DevPreviewProvider } from "@/dev/dev-preview-provider";
import { DevPanels, DevStatePreviewOverlay } from "@/dev/dev-tools-lazy";
import { ToastProvider } from "../feedback";
import { StepTransitionProvider } from "../transitions/transition-context";
import { Container } from "./container";
import { Footer } from "./footer";
import { Header } from "./header";

/**
 * `alert` is passed in rather than fetched here: `app/error.tsx` is a client
 * boundary that renders this shell, so it must not reach for server-only data.
 */
export function FlowShell({
	children,
	showDevControls = false,
	alert = null,
}: {
	children: React.ReactNode;
	showDevControls?: boolean;
	alert?: SigningAlert | null;
}) {
	return (
		<div id="app-container" className="flex min-h-dvh flex-col">
			<Header alert={alert} />
			<DevPreviewProvider showDevTools={showDevControls}>
				<ToastProvider>
					<StepTransitionProvider>
						<Container>
							{children}
							{showDevControls && <DevStatePreviewOverlay />}
						</Container>
					</StepTransitionProvider>
				</ToastProvider>
				<Footer />
				{showDevControls && <DevPanels />}
			</DevPreviewProvider>
		</div>
	);
}
